export const PHONE_NUMBER_REGEX =
  /^((\\+[1-9]{1,4}[ -]*)|(\\([0-9]{2,3}\\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/;
export const INTERNAL_REFERENCE_REGEX = /^[\w\d()#\-./:_\s]+$/;
